import React from 'react';
import './ContextualizerLegends.scss';
import { LegendItemType } from '../../components/card-viewer/CardViewer';

const ContextualizerLegends = (props: { legendsData: LegendItemType[] | undefined }) => {
  const { legendsData } = props;
  return (
    <section className='analytics-legend' role='img' aria-label='Analytics status legend'>
      <div className='analytics-legend__container'>
        {legendsData?.map((item) => (
          <>
            <div className={`legend-item legend-item--${item.id}`} role='listitem'>
              <div className='legend-item__container'>
                <div
                  className={`legend-item__indicator ${item.hasImage ? 'legend-item__indicator--image' : 'legend-item__indicator--color'}`}
                  style={{
                    backgroundColor: item.hasImage ? 'transparent' : item.color,
                    backgroundImage: item.hasImage && item.imageUrl ? `url(${item.imageUrl})` : 'none',
                  }}
                  aria-hidden='true'
                />
                <span className='legend-item__label'>{item.label}</span>
              </div>
            </div>
          </>
        ))}
      </div>
    </section>
  );
};

export default ContextualizerLegends;
